import React from 'react';
import { Modal } from 'flowbite-react';
import ButtonPrimary from '../button/ButtonPrimary';
import ButtonSecondary from '../button/ButtonSecondary';
import { toast } from 'react-hot-toast';

const CustomModal = ({
    open,
    onClose,
    onConfirm,
    title = 'Confirmation',
    description = 'Are you sure?',
    confirmText = 'Confirm',
    cancelText = 'Cancel'
}) => {
    const handleConfirm = async () => {
        try {
            await onConfirm();
        } catch (error) {
            toast.error(error.message);
        };
    };
    
    return (
        <Modal
            size='md'
            theme={
                {
                    root: {
                        base: 'fixed inset-0 z-50 h-screen overflow-y-auto overflow-x-hidden',
                        show: {
                            on: 'flex bg-blackOlive bg-opacity-50',
                            off: 'hidden'
                        },
                    },
                    content: {
                        base: 'relative h-auto w-full p-5',
                        inner: 'relative flex max-h-[90dvh] flex-col rounded-lg bg-white'
                    },
                    header: {
                        base: 'flex p-5 items-center justify-between rounded-t-lg border-b border-platinum',
                        title: 'text-base md:text-lg text-black font-semibold',
                        close: {
                            base: 'inline-flex items-center bg-transparent text-grayX11 hover:outline-none hover:text-black focus:outline-none focus:text-black',
                            popup: 'text-grayX11',
                            icon: 'h-5 w-5'
                        },
                    },
                    body: {
                        base: 'flex-1 p-5 overflow-auto',
                    },
                    footer: {
                        base: 'flex p-5 rounded-b items-center justify-end space-x-2.5',
                        popup: 'border-t border-platinum'
                    },
                }
            }
            show={open}
            onClose={onClose}
        >
            <Modal.Header>{title}</Modal.Header>
            <Modal.Body>
                <p className='text-xs md:text-sm text-black'>
                    {description}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <ButtonSecondary className='h-full w-18 md:w-24 md:text-sm' onClick={onClose}>{cancelText}</ButtonSecondary>
                <ButtonPrimary className='h-full w-18 md:w-24 md:text-sm' onClick={handleConfirm}>{confirmText}</ButtonPrimary>
            </Modal.Footer>
        </Modal>
    );
};

export default CustomModal;
